import { createRouter, createWebHashHistory } from 'vue-router';
import { TOKEN_DEFAULT } from '../helpers/security';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home/Index.vue')
    },
    {
        path: '/plantillas',
        name: 'Plantillas',
        component: () => import('../views/Plantilla/Index.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../login/LoginPage.vue')
    },
    {
        path: '/plantillas/create',
        name: 'Create Plantillas',
        component: () => import('../views/Plantilla/Create.vue')
    },
    {
        path: '/plantillas/edit/:id',
        name: 'Edit Plantillas',
        component: () => import('../views/Plantilla/Edit.vue')
    },
    {
        path: '/plantillas/design/:id',
        name: 'Design Plantillas',
        component: () => import('../views/Plantilla/Design.vue')
    },
    // CSV
    {
        path: '/csv',
        name: 'CSV',
        component: () => import('../views/CSV/Index.vue')
    },
    {
        path: '/csv/create',
        name: 'CSV create',
        component: () => import('../views/CSV/Create.vue')
    },
    {
        path: '/csv/detail/:id',
        name: 'CSV detail',
        component: () => import('../views/CSV/Detail.vue')
    },
    // EVIDENCIAS
    {
        path: '/evidencia',
        name: 'Evidencias',
        component: () => import('../views/Evidencia/Index.vue')
    },
    // Empresa
    {
        path: '/empresas',
        name: 'Empresas',
        component: () => import('../views/Empresa/Index.vue')
    },
    {
        path: '/empresas/create',
        name: 'Empresas Create',
        component: () => import('../views/Empresa/Create.vue')
    },
    {
        path: '/empresas/edit/:id',
        name: 'Empresas Edit',
        component: () => import('../views/Empresa/Edit.vue')
    },
     // EmailConfig
     {
        path: '/emailconfig',
        name: 'Emails',
        component: () => import('../views/EmailConfig/Index.vue')
    },
    {
        path: '/emailconfig/create',
        name: 'Emails Create',
        component: () => import('../views/EmailConfig/Create.vue')
    },
    {
        path: '/emailconfig/edit/:id',
        name: 'Emails Edit',
        component: () => import('../views/EmailConfig/Edit.vue')
    },
    //Diseño
    {
        path: '/formularioeditor/:id',
        name: 'Formulario Editor',
        component: () => import('../views/FormularioEditor/Index.vue'),
    },
    //Formularios
    {
        path: '/formularios/:id',
        name: 'Formulario',
        component: () => import('../views/Formulario/Index.vue'),
    },
    //Usuarios
    {
        path: '/usuarios',
        name: 'Usuarios',
        component: () => import('../views/Usuario/Index.vue'),
    },
    {
        path: '/usuarios/create',
        name: 'Usuario Create',
        component: () => import('../views/Usuario/Create.vue')
    },
    {
        path: '/usuarios/edit/:id',
        name: 'usuarios',
        component: () => import('../views/Usuario/Edit.vue'),
    },

     //Roles
     {
        path: '/roles',
        name: 'roles',
        component: () => import('../views/Rol/Index.vue'),
    },


    //OTHER
    {
        path: '/formlayout',
        name: 'formlayout',
        component: () => import('../components/FormLayoutDemo.vue'),
    },
    {
        path: '/input',
        name: 'input',
        component: () => import('../components/InputDemo.vue'),
    },
    {
        path: '/floatlabel',
        name: 'floatlabel',
        component: () => import('../components/FloatLabelDemo.vue'),
    },
    {
        path: '/invalidstate',
        name: 'invalidstate',
        component: () => import('../components/InvalidStateDemo.vue'),
    },
    {
        path: '/button',
        name: 'button',
        component: () => import('../components/ButtonDemo.vue'),
    },
    {
        path: '/table',
        name: 'table',
        component: () => import('../components/TableDemo.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () => import('../components/ListDemo.vue'),
    },
    {
        path: '/tree',
        name: 'tree',
        component: () => import('../components/TreeDemo.vue'),
    },
    {
        path: '/panel',
        name: 'panel',
        component: () => import('../components/PanelsDemo.vue'),
    },
    {
        path: '/overlay',
        name: 'overlay',
        component: () => import('../components/OverlayDemo.vue'),
    },
    {
        path: '/menu',
        component: () => import('../components/MenuDemo.vue'),
        children: [
            {
                path: '',
                component: () => import('../components/menu/PersonalDemo.vue'),
            },
            {
                path: '/menu/seat',
                component: () => import('../components/menu/SeatDemo.vue'),
            },
            {
                path: '/menu/payment',
                component: () => import('../components/menu/PaymentDemo.vue'),
            },
            {
                path: '/menu/confirmation',
                component: () => import('../components/menu/ConfirmationDemo.vue'),
            },
        ],
    },
    {
        path: '/messages',
        name: 'messages',
        component: () => import('../components/MessagesDemo.vue'),
    },
    {
        path: '/file',
        name: 'file',
        component: () => import('../components/FileDemo.vue'),
    },
    {
        path: '/chart',
        name: 'chart',
        component: () => import('../components/ChartDemo.vue'),
    },
    {
        path: '/misc',
        name: 'misc',
        component: () => import('../components/MiscDemo.vue'),
    },
    {
        path: '/display',
        name: 'display',
        component: () => import('../utilities/DisplayDemo.vue'),
    },
    {
        path: '/flexbox',
        name: 'flexbox',
        component: () => import('../utilities/FlexBoxDemo.vue'),
    },
    {
        path: '/text',
        name: 'text',
        component: () => import('../utilities/TextDemo.vue'),
    },
    {
        path: '/icons',
        name: 'icons',
        component: () => import('../utilities/Icons.vue'),
    },
    {
        path: '/grid',
        name: 'grid',
        component: () => import('../utilities/GridDemo.vue'),
    },
    {
        path: '/spacing',
        name: 'spacing',
        component: () => import('../utilities/SpacingDemo.vue'),
    },
    {
        path: '/elevation',
        name: 'elevation',
        component: () => import('../utilities/ElevationDemo.vue'),
    },
    {
        path: '/typography',
        name: 'typography',
        component: () => import('../utilities/Typography.vue'),
    },
    {
        path: '/crud',
        name: 'crud',
        component: () => import('../pages/CrudDemo.vue'),
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import('../pages/CalendarDemo.vue'),
    },
    {
        path: '/timeline',
        name: 'timeline',
        component: () => import('../pages/TimelineDemo.vue'),
    },
    {
        path: '/empty',
        name: 'empty',
        component: () => import('../components/EmptyPage.vue'),
    },
    {
        path: '/documentation',
        name: 'documentation',
        component: () => import('../views/Plantilla/Index.vue')
        //component: () => import('../components/Documentation.vue'),

        
    },
    {
        path: '/plantillas/create',
        name: 'plantilla/create',
        component: () => import('../views/Plantilla/Create.vue')
        //component: () => import('./components/Documentation.vue'),

        
    },
];

export const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    console.log(to.path.split('/')[1])
    const publicPages = ['login', 'about', 'formularios'];
    const path = to.path.split('/')[1];
    const authRequired = !publicPages.includes(path);


    if (path == 'formularios') {      
        localStorage.setItem('user', JSON.stringify({username: 'guest', token: TOKEN_DEFAULT}));
    }

    let loggedIn = localStorage.getItem('user');

    const user = JSON.parse(loggedIn);


    if (user && user.username === 'guest' && path !== 'formularios'){
        localStorage.removeItem('user');
        loggedIn = null;
    }
  
    if (authRequired && !loggedIn) {      
      return next('/login');
    }
  
    next();
  })